import React, {Dispatch, useEffect, useState} from "react";

export interface TimeRemainingProps {
    expiredAt: Date | null;
}

export default function TimeRemaining({expiredAt}: TimeRemainingProps) {
    const [timeRemaining, setTimeRemaining] = useState<number>(0);

    useEffect(() => {
        const trigger = setInterval(async () => {
            if (!expiredAt) return;

            const timeRemaining = Math.floor((expiredAt?.getTime() - Date.now()) / 1000);

            if (timeRemaining <= 0) {
                clearInterval(trigger);

                window.location.reload();
                return;
            }

            setTimeRemaining(() => {
                return timeRemaining;
            });
        }, 1000);

        return () => clearInterval(trigger);
    }, [expiredAt]);

    return (
        <p className="text-white/20">
            {Math.floor(timeRemaining / 60)} minutes remaining
        </p>
    );
}